export const VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW =
  'VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW';
export const VENDOR_INVOICES_INVOICE_ADD = 'VENDOR_INVOICES_INVOICE_ADD';
export const VENDOR_INVOICES_INVOICE_REMOVE = 'VENDOR_INVOICES_INVOICE_REMOVE';
export const VENDOR_INVOICES_SET = 'VENDOR_INVOICES_SET';
